import ContentScale from '../ContentScale/ContentScale'

/**
 * Scale mértékét adja vissza, ha a kiindulási (from) elem mérete nem egyezik meg a cél elem (to) méretével.
 * Ebben az esetben scale-elnünk is kell.
 * @param from - Kiindulási elem.
 * @param to   - Cél elem.
 */
export default function getScaleDifference (from: HTMLElement, to: HTMLElement): number {
  const ratio = ContentScale.getScaleRatio()

  const fromRect = ContentScale.getElementOffset(from, ratio)
  const toRect   = ContentScale.getElementOffset(to, ratio)

  const fromWidth = fromRect.width
  const toWidth   = toRect.width

  const scale = fromWidth > toWidth ? toWidth / fromWidth : fromWidth / toWidth

  return scale
}
